import(/* webpackMode: "eager" */ "/Users/christophkranebitter/renehuemer.com/website/src/app/work/[categorySlug]/error.tsx");
